<template>
  <div v-if="!disabled" class="form-floating" :class="'mb-'+mb">
    <input
        class="form-control form-control-solid"
        autocomplete="off"
        :placeholder="placeholder"
        :disabled="disabled"
        :autofocus="autofocus"
        :value="modelValue"
        :required="required"
        v-money="money"
        :class="hasError ? 'is-invalid' : ''"
        :type="type"
        :name="name"
        :id=id
        @input="updateValue"
    >
    <label :for=id :class="{ required: required }" v-html="placeholder"></label>
    <slot></slot>
  </div>
  <disabled-field v-else :value="modelValue" :mb="mb" :placeholder="placeholder" :required="required"/>
</template>

<script>
import { VMoney } from 'v-money'
import DisabledField from '@/components/Fields/DisabledField'

export default {
  name: 'CurrencyField',
  components: {DisabledField},
  props: {
    placeholder: null,
    modelValue: '',
    autofocus: false,
    required: false,
    hasError: false,
    disabled: null,
    class: null,
    type: null,
    name: null,
    mb:null,
    id:null
  },
  data () {
    return {
      money: {
        precision: 0,
        thousands: ' ',
        decimal:   '',
        prefix:    '',
        suffix:    '',
        masked:    false
      }
    }
  },
  directives: { money: VMoney },
  methods: {
    updateValue(event) {
      this.$emit('update:modelValue', parseInt(event.target.value.replace(/\s+/g, '')))
    }
  }
}
</script>

<style scoped>

</style>